import { render } from "./AddAssetCategory.vue?vue&type=template&id=020d7e49&scoped=true"
import script from "./AddAssetCategory.vue?vue&type=script&lang=js"
export * from "./AddAssetCategory.vue?vue&type=script&lang=js"

import "./AddAssetCategory.vue?vue&type=style&index=0&id=020d7e49&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020d7e49"]])

export default __exports__